
export interface ReducerSingleConfiguration {
    id: string;
    initialState?: any;
    handlers?: {
        [key: string]: string | Function
    };
}

export interface ReducerGroupConfiguration {
    id: string;
    children: ReducerConfiguration[];
}

export type ReducerConfiguration = ReducerSingleConfiguration | ReducerGroupConfiguration;

